import _ from 'lodash'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { skipToken } from '@reduxjs/toolkit/query'

import { useGetConsultationsQuery } from '@/core/services/consultation'
import { useGetExpertiseQuery } from '@/core/services/expertise'

import ConsultationsDialog, { ExpertiseConsultationsDialogProps } from '../components/ExpertiseConsultationsDialog'

export function ExpertiseConsultationsDialogContainer(props: Pick<ExpertiseConsultationsDialogProps, 'onAdd' | 'onClose' | 'onDelete' | 'onShow' | 'open'>) {
  const { open } = props

  const { expertiseId } = useParams()

  const { data: expertise } = useGetExpertiseQuery(expertiseId ?? skipToken)
  const { data: consultations } = useGetConsultationsQuery(
    { query: { patient: expertise?.patient._id }, options: { limit: 10 } },
    {
      skip: !expertise || !open,
      selectFromResult: ({ data, ...rest }) => ({
        ...rest,
        data: data?.[0] ?? [],
      }),
    }
  )

  const consultationsData = useMemo(() => {
    return _.map(consultations, (consultation) => ({
      id: consultation._id,
      added: !!_.find(expertise?.consultations, ({ _id }) => _id === consultation._id),
      doctor: _.trim(`${consultation.medecin?.userInfo.name || ''} ${consultation.medecin?.userInfo.surname || ''}`),
      filesCount: consultation.files.length,
      mesuresCount: _.filter(consultation.mesures, (mesure) => mesure.value).length,
      startDate: consultation.startDate,
    }))
  }, [consultations, expertise])

  return <ConsultationsDialog {...props} data={consultationsData} />
}

export default ExpertiseConsultationsDialogContainer
